// --- ICONS from theme (Liquid-injected) ---
const ICONS = (typeof window !== "undefined" && window.themeIcons) ? window.themeIcons : {
  add: "/icons/icon-add-circle.svg",            // fallback if Liquid wasn't injected
  minus: "/icons/icon-minus-circle.svg",
  down: "/icons/icon-down-arrow-2.svg",
  up: "/icons/icon-up-arrow.svg"
};


// ----------------- Mobile menu -----------------
const menuToggle = document.getElementById("menuToggle");
const mobileMenu = document.getElementById("mobileMenu");
const hamburgerIcon = document.getElementById("hamburgerIcon");
const closeIcon = document.getElementById("closeIcon");

if (menuToggle && mobileMenu && hamburgerIcon && closeIcon) {
  menuToggle.addEventListener("click", () => {
    const isOpen = !mobileMenu.classList.contains("hidden");

    if (isOpen) {
      // Close menu
      mobileMenu.classList.add("hidden");
      hamburgerIcon.classList.remove("hidden");
      closeIcon.classList.add("hidden");
      document.body.classList.remove("no-scroll");
    } else {
      // Open menu
      mobileMenu.classList.remove("hidden");
      hamburgerIcon.classList.add("hidden");
      closeIcon.classList.remove("hidden");
      document.body.classList.add("no-scroll");
    }
  });
}

// ----------------- Video modal -----------------
const videoModal = document.getElementById("videoModal");
const videoFrame = document.getElementById("videoFrame");
const videoContent = document.getElementById("videoContent");
const videoClose = document.getElementById("videoClose");

if (videoModal && videoFrame && videoContent && videoClose) {
  document.querySelectorAll(".video-trigger").forEach((btn) => {
    btn.addEventListener("click", () => {
      const videoUrl = btn.getAttribute("data-video");
      videoFrame.src = videoUrl;

      // Stop video swiper when video modal opens
      if (videoSwiper && videoSwiper.autoplay) {
        videoSwiper.autoplay.stop();
      }

      videoModal.classList.remove("hidden");
      videoModal.classList.add("flex");

      videoContent.classList.remove("video-animate");
      void videoContent.offsetWidth;
      videoContent.classList.add("video-animate");
    });
  });

  videoClose.addEventListener("click", () => {
    videoModal.classList.add("hidden");
    videoModal.classList.remove("flex");
    videoFrame.src = "";

    // Restart video swiper when video modal closes (only on desktop)
    if (videoSwiper && videoSwiper.autoplay && window.innerWidth >= 1024) {
      videoSwiper.autoplay.start();
    }
  });
}

// ----------------- Generic FAQ helpers -----------------
function setupFAQItem(headerEl, answerEl, iconEl, addIcon, minusIcon) {
  if (!headerEl || !answerEl || !iconEl) return;

  // Initialize icon src to current state
  // If visible, use minus, else add
  const isInitiallyOpen = answerEl.style.display !== "none" && answerEl.offsetParent !== null;
  iconEl.src = isInitiallyOpen ? minusIcon : addIcon;

  let isOpen = isInitiallyOpen;

  headerEl.addEventListener("click", () => {
    isOpen = !isOpen;

    if (isOpen) {
      iconEl.src = minusIcon;
      answerEl.style.display = "block";
    } else {
      iconEl.src = addIcon;
      answerEl.style.display = "none";
    }
  });
}

// ----------------- MI items (uses down/up icons) -----------------
document.querySelectorAll(".mi-item").forEach((item) => {
  const header = item.querySelector(".mi-header");
  const answer = item.querySelector(".mi-answer");
  const icon = item.querySelector(".mi-icon");

  setupFAQItem(
    header,
    answer,
    icon,
    ICONS.down,   // addIcon (collapsed)
    ICONS.up      // minusIcon (expanded)
  );
});

// ----------------- FAQ items (uses add/minus icons) -----------------
document.querySelectorAll(".faq-item").forEach((item) => {
  const header = item.querySelector(".faq-header");
  const answer = item.querySelector(".faq-answer");
  const icon = item.querySelector(".faq-icon");

  setupFAQItem(
    header,
    answer,
    icon,
    ICONS.add,    // add icon from theme assets
    ICONS.minus   // minus icon from theme assets
  );
});

// ----------------- Best selling & detective (layout toggle + swiper) -----------------
const mobileDivs = document.querySelectorAll(".mobile-layout");
const desktopDivs = document.querySelectorAll(".desktop-layout");

function toggleLayout() {
  if (window.innerWidth < 768) {
    mobileDivs.forEach((div) => (div.style.display = "block"));
    desktopDivs.forEach((div) => (div.style.display = "none"));
  } else {
    mobileDivs.forEach((div) => (div.style.display = "none"));
    desktopDivs.forEach((div) => (div.style.display = "block"));

    desktopDivs.forEach((div) => {
      if (!div.dataset.swiperInit) {
        new Swiper(div, {
          loop: true,
          slidesPerView: 3,
          spaceBetween: 32,
          autoplay: { delay: 2000 },
        });
        div.dataset.swiperInit = true;
      }
    });
  }
}
toggleLayout();
window.addEventListener("resize", toggleLayout);

// ----------------- Scoped swiper -----------------
function initScopedSwiper(scopeEl) {
  const swiperContainer = scopeEl.querySelector(".swiperPackage");
  const swiperPackageWrapper = scopeEl.querySelector(".swiperPackageWrapper");
  const customPagination = scopeEl.querySelector(".custom-pagination");

  const prevBtn = scopeEl.querySelector(".swiper-prev");
  const nextBtn = scopeEl.querySelector(".swiper-next");

  let swiperInstance = null;

  function bindArrowNavigation(swiper) {
    if (prevBtn) prevBtn.addEventListener("click", () => swiper.slidePrev());
    if (nextBtn) nextBtn.addEventListener("click", () => swiper.slideNext());
  }

  function createCustomPagination(swiper) {
    if (!customPagination) return;
    customPagination.innerHTML = "";

    swiper.slides.forEach((_, i) => {
      const btn = document.createElement("button");
      btn.className = "h-2 w-2 cursor-pointer rounded-full transition flex items-center justify-center";

      const span = document.createElement("span");
      span.className = "block h-2 w-2 rounded-full " + (i === swiper.realIndex ? "bg-pumpkin-500" : "bg-black/20");

      btn.appendChild(span);
      btn.addEventListener("click", () => swiper.slideToLoop(i));
      customPagination.appendChild(btn);
    });
  }

  function updateCustomPagination(swiper) {
    if (!customPagination) return;
    const spans = customPagination.querySelectorAll("span");
    spans.forEach((span, i) => {
      span.className = "block h-2 w-2 rounded-full " + (i === swiper.realIndex ? "bg-pumpkin-500" : "bg-black/20");
    });
  }

  function toggleSwiper() {
    if (!swiperContainer || !swiperPackageWrapper) return;

    if (window.innerWidth >= 1024) {
      if (!swiperContainer.classList.contains("swiper")) {
        swiperContainer.classList.add("swiper");
        swiperPackageWrapper.classList.remove("grid-cols-2", "gap-6");
        swiperPackageWrapper.setAttribute("style", "display:grid;");
        swiperPackageWrapper.removeAttribute("style");
      }

      if (!swiperInstance) {
        swiperInstance = new Swiper(swiperContainer, {
          loop: true,
          autoplay:false,
          breakpoints: {
            0: { enabled: false },
            768: { slidesPerView: 3, spaceBetween: 32, enabled: true },
            1024: { slidesPerView: 4, spaceBetween: 32, enabled: true },
          },
          on: {
            afterInit: function () {
              createCustomPagination(this);
              bindArrowNavigation(this);
            },
            slideChange: function () {
              updateCustomPagination(this);
            },
          },
        });
      }
    } else {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      swiperContainer.classList.remove("swiper");
      swiperPackageWrapper.classList.add("grid-cols-2", "gap-6");
      swiperPackageWrapper.setAttribute("style", "display:grid;");
      if (customPagination) customPagination.innerHTML = "";
    }
  }

  toggleSwiper();
  window.addEventListener("resize", toggleSwiper);
}

document.querySelectorAll(".swiperScope").forEach((scope) => initScopedSwiper(scope));

// ----------------- Product Image Swiper with thumbs -----------------
function initResponsiveSwiper() {
  const scope = document.querySelector(".swiperProductScope");
  if (!scope) return;

  const swiperContainer = scope.querySelector(".swiperProduct");
  const swiperWrapper = scope.querySelector(".swiper-wrapper");
  const customPagination = scope.querySelector(".custom-pagination");

  let swiperInstance = null;

  function buildThumbs(slides) {
    if (!customPagination) return;
    customPagination.innerHTML = "";
    slides.forEach((slide, index) => {
      const img =
        slide.querySelector("img.product-image") ||
        slide.querySelector("img.w-full") ||
        slide.querySelector("img.rounded-2xl") ||
        Array.from(slide.querySelectorAll("img")).pop();

      const src = img ? img.src : "";

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "swiper-thumb w-full sm:max-w-[80px] h-auto overflow-hidden rounded-2xl border-2 border-transparent opacity-60";
      btn.innerHTML = `<img src="${src}" class="w-full h-full object-cover" alt="thumb-${index}" />`;

      btn.addEventListener("click", () => {
        if (swiperInstance) swiperInstance.slideToLoop(index, 300);
      });

      customPagination.appendChild(btn);
    });
  }

  function updateThumbs(activeIndex) {
    if (!customPagination) return;
    const btns = customPagination.querySelectorAll("button");
    btns.forEach((btn, i) => {
      if (i === activeIndex) {
        btn.classList.add("border-pumpkin-500");
        btn.classList.remove("opacity-60");
      } else {
        btn.classList.remove("border-pumpkin-500");
        btn.classList.add("opacity-60");
      }
    });
  }

  function enableSwiper() {
    if (!swiperContainer || !swiperWrapper) return;

    if (!swiperInstance) {
      swiperContainer.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperWrapper.classList.remove("grid", "grid-cols-2", "gap-8");

      swiperInstance = new Swiper(swiperContainer, {
        loop: true,
        speed: 500,
        autoplay:false,
        navigation: { nextEl: ".swiper-next", prevEl: ".swiper-prev" },
        breakpoints: {
          0: { slidesPerView: "auto", spaceBetween: 16, centeredSlides: true },
          340: { slidesPerView: "auto", centeredSlides: false, spaceBetween: 32 },
          768: { slidesPerView: "auto", spaceBetween: 32, centeredSlides: false }
        },
        on: {
          init: function () {
            const realSlides = Array.from(this.slides).filter(
              (s) => !s.classList.contains("swiper-slide-duplicate")
            );
            buildThumbs(realSlides);
            updateThumbs(this.realIndex);
          },
          slideChange: function () {
            updateThumbs(this.realIndex);
          },
        },
      });
    }
    if (customPagination) customPagination.style.display = "flex";
  }

  function disableSwiper() {
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
    if (swiperContainer) swiperContainer.classList.remove("swiper");
    if (swiperWrapper) {
      swiperWrapper.classList.remove("swiper-wrapper");
      swiperWrapper.classList.add("grid", "grid-cols-2", "gap-8");
    }
    if (customPagination) customPagination.style.display = "none";
  }

  function toggleSwiper() {
    if (window.innerWidth <= 1024) {
      enableSwiper();
    } else {
      disableSwiper();
    }
  }

  toggleSwiper();
  window.addEventListener("resize", toggleSwiper);
}
initResponsiveSwiper();


(function () {
  'use strict';

  // ------------ helpers ------------
  function isOembed(url) {
    return /youtube\.com|youtu\.be|vimeo\.com/i.test(url || '');
  }

  function toEmbedUrl(url) {
    try {
      var u = new URL(url);
      var h = u.hostname.toLowerCase();

      // youtu.be/ID
      if (h.indexOf('youtu.be') !== -1) {
        var idShort = u.pathname.replace('/', '');
        return 'https://www.youtube.com/embed/' + idShort + '?autoplay=1&rel=0&modestbranding=1';
      }

      // youtube.com/watch?v=ID or already /embed/*
      if (h.indexOf('youtube.com') !== -1) {
        var id = u.searchParams.get('v');
        return id
          ? 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1'
          : u.origin + u.pathname + '?autoplay=1&rel=0&modestbranding=1';
      }

      // vimeo.com/ID
      if (h.indexOf('vimeo.com') !== -1) {
        var parts = u.pathname.split('/').filter(Boolean);
        var vimeoId = parts[parts.length - 1];
        return 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&title=0&byline=0&portrait=0';
      }
    } catch (e) {}
    return url; // not YT/Vimeo -> likely a direct file URL
  }

  function requestFullscreen(elem) {
    var goFS = elem.requestFullscreen || elem.webkitRequestFullscreen || elem.msRequestFullscreen || elem.mozRequestFullScreen;
    if (!goFS) return Promise.reject(new Error('FS not supported'));
    try {
      var p = goFS.call(elem);
      // Some browsers return undefined; normalize to a Promise
      return (p && typeof p.then === 'function') ? p : Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  }

  function addBasicStyles(el) {
    el.style.position = 'fixed';
    el.style.inset = '0';
    el.style.background = '#000';
    el.style.zIndex = '999999';
  }

  function cleanup(container) {
    document.removeEventListener('fullscreenchange', onFSChange, true);
    document.removeEventListener('webkitfullscreenchange', onFSChange, true);
    document.removeEventListener('keydown', onEsc, true);
    if (container && container.parentNode) container.parentNode.removeChild(container);
  }

  function onFSChange() {
    // When FS exits, remove the container
    if (!document.fullscreenElement && !document.webkitFullscreenElement) {
      cleanup(activeContainer);
      activeContainer = null;
    }
  }

  function onEsc(e) {
    if (e.key === 'Escape') {
      cleanup(activeContainer);
      activeContainer = null;
    }
  }

  var activeContainer = null;
});


//add to cart

(() => {
  const form = document.querySelector('#add-to-cart-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault(); // Stop Shopify from doing a full page reload

    const formData = new FormData(form);
    const variantId = formData.get('id');

    if (!variantId) {
      alert('Please select a variant before adding to cart.');
      return;
    }

  });
})();


  $(document).ready(function(){
    // Toggle display of dropdown-menu on click of dropdown-toggle
    $('.open-dropdown').click(function(e){ // Prevent event bubbling

      const dropdownToOpen = $(this).closest('.dropdown').find(".dropdown");
      console.log(dropdownToOpen.hasClass("hidden"))
      if (dropdownToOpen.hasClass("hidden")) return dropdownToOpen.removeClass("hidden");
      dropdownToOpen.addClass("hidden");

    })
});

  
  function toggleHints(hintsContainerId) {
    var hintsContainer = document.getElementById(hintsContainerId);
    if (hintsContainer.style.display === 'none' || hintsContainer.style.display === '') {
      hintsContainer.style.display = 'block';
    } else {
      hintsContainer.style.display = 'none';
    }
  }

  function toggleHintOptions(event, hintOptionsId) {
    event.preventDefault(); // Prevent the default anchor behavior
    var hintOptions = document.getElementById(hintOptionsId);
    if (hintOptions.style.display === 'none' || hintOptions.style.display === '') {
      hintOptions.style.display = 'block';
    } else {
      hintOptions.style.display = 'none';
    }
  }

//SLIDER OF LOGOS

// LOGO SLIDER - Swiper + jQuery
(function ($) {
  $(document).ready(function () {
    const selector = '.featured-logos-swiper';

    // Make sure Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not loaded.');
      return;
    }

    // Wait until the DOM is ready and Swiper container exists
    const $container = $(selector);
    if ($container.length === 0) {
      console.warn('Swiper container not found.');
      return;
    }

    console.log('Initializing Featured Logos Swiper...'); // ta
 
    // Fixed speed for consistent movement across all sliders
    const speed = 8000; // Same speed for both sliders

    // Initialize Swiper
    const swiper = new Swiper(selector, {
      slidesPerView: 6,
      spaceBetween: 92,
      loop: true,
      allowTouchMove: false,
      speed: speed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      },
      freeMode: true,
      freeModeMomentum: false,
      centeredSlides: false,
      grabCursor: false,
      cssMode: false,
      watchOverflow: false, // Prevents stopping when not enough slides
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 92,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 92,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 92,
        },
        1280: {
          slidesPerView: 6,
          spaceBetween: 92,
        },
      },
    });

    // Ensure linear timing for smooth scrolling and prevent stopping
    $(`${selector} .swiper-wrapper`).css({
      'transition-timing-function': 'linear',
      'animation-play-state': 'running'
    });

    console.log('Featured Logos Swiper initialized successfully.');
  });
})(jQuery);

// PROMOTION BANNER SLIDER - Separate initialization
(function ($) {
  $(document).ready(function () {
    const selector = '.promotion-banner-swiper';

    // Make sure Swiper is loaded
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not loaded for promotion banner.');
      return;
    }

    // Wait until the DOM is ready and Swiper container exists
    const $container = $(selector);
    if ($container.length === 0) {
      console.warn('Promotion banner swiper container not found.');
      return;
    }

    console.log('Initializing Promotion Banner Swiper...');

    // Count actual slides
    const actualSlides = $container.find('.swiper-slide').length;
    console.log('Actual slides found:', actualSlides);

    if (actualSlides === 0) {
      console.warn('No slides found in promotion banner');
      return;
    }

    // Fixed speed for consistent movement - SAME as featured-logos
    const speed = 8000; // Same speed for both sliders

    // Simplified slidesPerView logic - always enable loop
    const getMaxSlidesPerView = (desiredSlides) => {
      return actualSlides >= desiredSlides ? desiredSlides : actualSlides;
    };

    // Initialize Swiper with identical settings to featured-logos
    const swiper = new Swiper(selector, {

      slidesPerView: 'auto',
      spaceBetween: 42,
      loop: true,
      allowTouchMove: false,
      speed: speed,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
        reverseDirection: false,
      },
      freeMode: true,
      freeModeMomentum: false,
      centeredSlides: false,
      grabCursor: false,
      cssMode: false,
      watchOverflow: false, // Prevents stopping when not enough slides


      breakpoints: {
        0: {
          slidesPerView: 'auto',
           spaceBetween:0,
        },
        768: {
          slidesPerView: 'auto',
            spaceBetween:0,
        },
        1024: {
          slidesPerView: 'auto',
            spaceBetween: 42,
        },
      },
    });

    // Ensure linear timing for smooth scrolling and prevent stopping
    $(`${selector} .swiper-wrapper`).css({
      'transition-timing-function': 'linear',
      'animation-play-state': 'running'
    });

    // Prevent click-to-pause: disable pointer events on slides
    $(`${selector} .swiper-slide`).css('pointer-events', 'none');

    // Restart autoplay if it stops (fallback)
    setInterval(() => {
      if (swiper && swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    }, 5000);

    console.log('Promotion Banner Swiper initialized with', actualSlides, 'slides');
  });
})(jQuery);

(function () {
  const btn = document.getElementById("back-to-top");
  if (!btn) return;

  function toggleBackToTop() {
    const trigger = window.innerHeight;
    const scrolled = window.scrollY || window.pageYOffset;

    if (scrolled > trigger) {
      btn.classList.remove("hidden");
      btn.classList.add("flex");
    } else {
      // hide
      btn.classList.add("hidden");
      btn.classList.remove("flex");
    }
  }

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  toggleBackToTop();
  window.addEventListener("scroll", toggleBackToTop);
})();



